import SecurityDeposit from './SecurityDeposit';

export default SecurityDeposit;
